namespace GeniuzPOS.Inventory {
    export interface IcStockReceiveDtForm {
        Id: Serenity.IntegerEditor;
        LineItemNo: Serenity.IntegerEditor;
        SkuCode: Serenity.LookupEditor;
        ItemRemark: Serenity.StringEditor;
        UnitChange: Serenity.EnumEditor;
        PurUnit: Serenity.StringEditor;
        PurUnitPrice: Serenity.DecimalEditor;
        LastPurPrice: Serenity.DecimalEditor;
        PurUnitRatio: Serenity.DecimalEditor;
        Qty: Serenity.DecimalEditor;
        CostValue: Serenity.DecimalEditor;
        UnitCost: Serenity.DecimalEditor;
        Remark: Serenity.StringEditor;
        ExpDate: Serenity.DateEditor;
    }

    export class IcStockReceiveDtForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.IcStockReceiveDt';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!IcStockReceiveDtForm.init)  {
                IcStockReceiveDtForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.LookupEditor;
                var w2 = s.StringEditor;
                var w3 = s.EnumEditor;
                var w4 = s.DecimalEditor;
                var w5 = s.DateEditor;

                Q.initFormType(IcStockReceiveDtForm, [
                    'Id', w0,
                    'LineItemNo', w0,
                    'SkuCode', w1,
                    'ItemRemark', w2,
                    'UnitChange', w3,
                    'PurUnit', w2,
                    'PurUnitPrice', w4,
                    'LastPurPrice', w4,
                    'PurUnitRatio', w4,
                    'Qty', w4,
                    'CostValue', w4,
                    'UnitCost', w4,
                    'Remark', w2,
                    'ExpDate', w5
                ]);
            }
        }
    }
}
